module.exports = __webpack_public_path__ + "static/media/newfoil.05a0e551.jpg";